// @flow strict
import * as React from 'react';

export type MagazineImage = {
  id: ?number,
  title: string,
  url: string,
  uploadPath: string,
  alt: string,
};

export type MagazineTerm = {
  id: ?number,
  slug: string,
  name: string,
};

export type MagazinePostSummary = {
  id: number,
  language: string,
  slug: string,
  urlPath: string,
  title: string,
  excerpt: string,
  date: ?string,
  modified: ?string,
  authorId: ?number,
  authorName: string,
  categories: MagazineTerm[],
  tags: MagazineTerm[],
  featuredImage: ?MagazineImage,
  seo: {
    title: string,
    description: string,
    readingTimeMinutes: ?number,
  },
};

export type MagazinePost = {
  ...MagazinePostSummary,
  type: string,
  excerptHtml: string,
  contentHtml: string,
  authorLogin: string,
  seo: {
    title: string,
    description: string,
    canonical: string,
    ogTitle: string,
    ogDescription: string,
    ogImage: ?string,
    twitterTitle: string,
    twitterDescription: string,
    twitterImage: ?string,
    readingTimeMinutes: ?number,
  },
  translations: {
    [language: string]: string,
  },
};

export type MagazineContextType = {
  indexPage: ?MagazinePost,
  currentPost: ?MagazinePost,
  posts: MagazinePostSummary[],
  recentPosts: MagazinePostSummary[],
  authors: Object,
  categories: Object[],
  tags: Object[],
};

const MagazineContext = React.createContext<MagazineContextType>({
  indexPage: null,
  currentPost: null,
  posts: [],
  recentPosts: [],
  authors: {},
  categories: [],
  tags: [],
});

export default MagazineContext;
